/**
 * Wishlist Image Placeholder — Swym 위시리스트 드로어 카드의 이미지 없는 상품에 placeholder SVG inject.
 *
 * 트리거: SwymCallbacks 안에서 drawer DOM mutation observe.
 *
 * 검출 패턴:
 *   - img.naturalWidth === 0 && img.complete (이미지 로드 실패)
 *   - img.src 가 비어있음 / 'no-image' 패턴
 *   - img onerror 이벤트
 *
 * 인젝션:
 *   - window.MISTO_IMG_PLACEHOLDER_SVG (theme.liquid 의 'product-1' placeholder_svg_tag) 사용
 *   - img 를 placeholder SVG wrapper 로 대체 (img 자체는 display:none)
 *
 * SSOT:
 *   - placeholder = Shopify built-in 'product-1' (card-product.liquid:113 과 동일)
 *
 * 회귀 함정:
 *   - Swym drawer 가 dynamically 다시 render 됨 → MutationObserver 로 새 카드도 처리
 *   - 이미 처리한 img 는 data-placeholder-applied 마킹으로 중복 방지
 */

(function () {
  'use strict';

  // 🔴 정확한 셀렉터 = swym-storefront-layout-item (grid- 없음). wishlist-brand-inject.js:24 와 동일 SSOT
  const CARD_SELECTOR = 'swym-storefront-layout-item[data-empi]';
  const APPLIED_ATTR = 'data-misto-placeholder-applied';
  const EMPTY_SRC_PATTERNS = [
    /no[-_]image/i,
    /default[-_]product/i,
    /shopify[-_]default/i,
    /placeholder/i,
  ];

  function isEmptyImage(img) {
    if (!img) return false;
    if (img.hasAttribute(APPLIED_ATTR)) return false;
    if (!img.src || img.src === window.location.href) return true;
    if (img.complete && img.naturalWidth === 0) return true;
    const src = img.src.toLowerCase();
    return EMPTY_SRC_PATTERNS.some(function (p) {
      return p.test(src);
    });
  }

  function injectPlaceholder(img) {
    let svgHTML = window.MISTO_IMG_PLACEHOLDER_SVG;
    // 🔴 [2026-05-29] fallback — theme.liquid 의 window.MISTO_IMG_PLACEHOLDER_SVG 가
    //    로그인(employee) 컨텍스트 등에서 미설정인 케이스 방어. 페이지에 이미 렌더된
    //    Shopify 'product-1' placeholder SVG (PLP 카드 등) 를 재사용 → 동일 SSOT.
    if (!svgHTML) {
      const existing = document.querySelector('svg.placeholder-svg');
      if (existing) svgHTML = existing.outerHTML;
    }
    if (!svgHTML) return;
    img.setAttribute(APPLIED_ATTR, '');
    // 🔴 img.src 자체를 SVG data URL 로 교체. img 의 wrapper/size CSS (Swym 측) 그대로 유지 → SVG 가 카드 크기에 맞춰 표시됨.
    //    PLP 의 card-product.liquid:113 와 동일 SVG ('product-1' placeholder_svg_tag) — SSOT 일치.
    const dataUrl = 'data:image/svg+xml;utf8,' + encodeURIComponent(svgHTML);
    img.src = dataUrl;
    if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    img.style.objectFit = 'contain';
    img.style.backgroundColor = '#f5f5f5';
  }

  function processCard(card) {
    const imgs = card.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (isEmptyImage(img)) {
        injectPlaceholder(img);
      } else if (!img.complete && !img.hasAttribute(APPLIED_ATTR)) {
        // 로드 실패 시 placeholder
        img.addEventListener(
          'error',
          function () {
            if (isEmptyImage(img)) injectPlaceholder(img);
          },
          { once: true }
        );
      }
    });
  }

  function processAllCards(root) {
    const cards = (root || document).querySelectorAll(CARD_SELECTOR);
    cards.forEach(processCard);
  }

  function startObserver() {
    const drawer = document.querySelector('swym-storefront-layout-as-drawer, #swym-storefront-layout');
    if (!drawer) return;

    processAllCards(drawer);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(CARD_SELECTOR)) {
            processCard(node);
          } else if (node.querySelectorAll) {
            processAllCards(node);
          }
        });
      });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
  });
})();
